import { AttributeBase, AttributeOptions } from './attribute-base';

export class ButtonAttribute extends AttributeBase<string> {
  public override controlType = 'button';
  public override options: string[] = [];
  public override type: string;

  constructor(options: AttributeOptions = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}
